export const CALC_PAYMENT = 'Calculate Another Payment';
export const SAMP_PAYMENT = 'Sample Payment';
export const MODAL_TITLE = 'Payment Calculator';
export const PRICE = 'Price';
export const DOWN_PAYMENT = 'Down Payment';
export const TERM = 'Term';
export const EST_MONTHLY_PAYMENT = 'Estimated Monthly Payment';
export const RESET = 'Reset';



// WEBPACK FOOTER //
// ./src/constants/labels.js